import React from 'react';

const Contact = () => {
    return (
        <div className='text-center my-36'>
            <h1 className="text-5xl">Comming Soon...</h1>
        </div>
    );
};

export default Contact;